import { 
    LOGIN, 
    GET_AUTH_USER,
    LOGOUT
} from 'redux/actions/types';
import { getAuthUser, login, logoutRequest } from "requests/auth";
import { setCookie, removeCookie } from "utils/cookie";

export const loginAction = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return login(data)
            .then(response => {
                const { distributor, access_token } = response.data.data;
                dispatch({ type: LOGIN, payload: { user: distributor } });
                setCookie(process.env.REACT_APP_TOKEN_NAME, access_token, 1 / 24);
                resolve(distributor);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const getAuthUserAction = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        return getAuthUser().then(response => {
            dispatch({ type: GET_AUTH_USER, payload: { user: response.data.data } });
            setCookie(process.env.REACT_APP_TOKEN_NAME, response.data.token, 1 / 24);
            resolve(response.data.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const logoutAction = () => async (dispatch) => {
    try {
        await logoutRequest(); 
    } catch (error) {
        console.error("Logout API failed", error); 
    } finally {
        dispatch({ type: LOGOUT });
        removeCookie(process.env.REACT_APP_TOKEN_NAME);
    }
};